import { render, staticRenderFns } from "./BusinessType.vue?vue&type=template&id=25725fe8&scoped=true"
import script from "./BusinessType.vue?vue&type=script&lang=js"
export * from "./BusinessType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25725fe8",
  null
  
)

export default component.exports